import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: '99曜阳' }
  },
  {
    path: '/activity',
    name: 'Activity',
    component: () => import('../views/activity/activity.vue'),
    meta: { title: '志愿活动' }
  },
  {
    path: '/activityDetail',
    name: 'ActivityDetail',
    component: () => import('../views/activity/activityDetail.vue'),
    meta: { title: '志愿活动详情' }
  },
  {
    path: '/train',
    name: 'Train',
    component: () => import('../views/train/train.vue'),
    meta: { title: '志愿者培训' }
  },
  {
    path: '/notice',
    name: 'Notice',
    component: () => import('../views/notice/notice.vue'),
    meta: { title: '公示公告' }
  },
  {
    path: '/noticeDetail',
    name: 'NoticeDetail',
    component: () => import('../views/notice/noticeDetail.vue'),
    meta: { title: '公示公告详情' }
  },
  {
    path: '/directories',
    name: 'Directories',
    component: () => import('../views/directories/directories.vue'),
    meta: { title: '志愿者目录' }
  },
  {
    path: '/bank',
    name: 'Bank',
    component: () => import('../views/bank/bank.vue'),
    meta: { title: '时间银行' }
  },
  {
    path: '/cooperation',
    name: 'Cooperation',
    component: () => import('../views/cooperation/cooperation.vue'),
    meta: { title: '对外合作' }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/login/login.vue'),
    meta: { title: '登陆' }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/login/register.vue'),
    meta: { title: '注册' }
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  //beforeEach是router的钩子函数，在进入路由前执行
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = '99曜阳'
  }
  next()
})

export default router
